import { InstanceScreen } from 'component/navigation/instance';

export default function SpacePromptHistoryScreen() {
    return <InstanceScreen screenKey='prompthistory' />;
}
